import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SpesenService} from '../../spesen.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {loadSpesenFailed, loadSpesenStart, loadSpesenSucceeded} from '../actions/getAllSpesen.actions';
import {deleteSpeseFailed, deleteSpeseStart, deleteSpeseSucceeded} from '../actions/spese-del.actions';
import {loadSpesenartenFailed, loadSpesenartenStart, loadSpesenartenSucceeded} from '../actions/spesenart.actions';
import {addSpesenFailed, addSpesenStart, addSpesenSucceeded} from '../actions/spesen-add.actions';
import {editSpesenFailed, editSpesenStart, editSpesenSucceeded} from '../actions/spesen-edit.actions';
import {deleteAllSpesenOfZeitStart, deleteAllSpesenOfZeitSucceeded} from '../actions/allSpesenOfZeit-del.actions';
import {getFilteredSeekDateStart} from '../actions/filter-seek-date.actions';
import {CacheService} from '../../cache.service';
import {addCacheFailed, addCacheStart, addCacheSucceeded} from '../actions/cache-add.actions';
import {loadCacheFailed, loadCacheStart, loadCacheSucceeded} from '../actions/getCacheNodes.actions';
import {
  loadTaetCacheFailed,
  loadTaetCacheStart,
  loadTaetCacheSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getTaetCache.actions';

@Injectable()
export class CacheEffects {

  public addCache$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addCacheStart),
      mergeMap((cache) =>
        this.cacheService.addCache(cache.item).pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of( addCacheSucceeded({item: response.data}))),
          catchError((e) => of(addCacheFailed(e))),
        ),
      ),
    ),
  );


  public loadCache$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCacheStart),
      mergeMap(() =>
        this.cacheService.loadCache().pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of( loadCacheSucceeded({item: response.data}))),
          catchError((e) => of(loadCacheFailed(e))),
        ),
      ),
    ),
  );

  public loadTaetCache$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTaetCacheStart),
      mergeMap((taetCache) =>
        this.cacheService.loadTaetCache(taetCache.prjId, taetCache.eingabe).pipe(
          // tslint:disable-next-line:max-line-length
          mergeMap((response) => of( loadTaetCacheSucceeded({item: response}))),
          catchError((e) => of(loadTaetCacheFailed(e))),
        ),
      ),
    ),
  );
  /**
   * Constructor of Zeit effects
   *
   * @param actions$ - The action observable
   * @param dS = DummyService - The Zeit service
   */
  constructor(private actions$: Actions, private cacheService: CacheService) {}
}
